import { Table, TableProps } from 'antd';
import { FC } from 'react';

import { ReportData } from '../../models/report';

export const ReportDataTable: FC<Omit<TableProps<ReportData>, 'rowKey'>> = props => {
  return <Table<ReportData> {...props} />;
};
